export const url =
  process.env.NODE_ENV === "development" ? "http://192.168.1.106:9080" : "https://tappydev.com";
// export const url = 'https://tappydev.com'
